export function getAccountDisplayName(accountName: string | null | undefined, index: number): string {
  const trimmed = accountName?.trim();
  return trimmed || `Account ${index + 1}`;
}

export function getAccountSubLabel(accountId: string): string {
  return accountId;
}
